var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"min-w-11/12 md:min-w-1/2 xl:min-w-1/3 flex items-center justify-center border-dashed border-gray-500 border-2 focus-ring focus-ring-muted py-6 px-8 w-full fill-current text-gray-400",attrs:{"type":"button"},on:{"click":_vm.addCalculation}},[_c('font-awesome-icon',{attrs:{"icon":"plus","size":"7x"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }